


























import {Component, Vue, Prop} from 'vue-property-decorator';
import {getStationName, RideTags, TrainRideInfo} from '@/data/train-store';
import TrainStation from './TrainStation.vue';
import LoadBar from '@/components/LoadBar.vue';

@Component({
  components: {TrainStation, LoadBar}
})
export default class TrainRideLine extends Vue {
  @Prop(Object) public ride!: TrainRideInfo;

  private tagsMapping = {
    [RideTags.REARGUARD]: {
      letter: 'מ',
      style: {
        background: 'lightblue',
        color: 'grey'
      }
    }
  };

  get tags() {
    return this.ride.tags.map((x) => this.tagsMapping[x]);
  }

  get destinationName() {
    return getStationName(this.ride.destinationId);
  }
}
